import { useEffect, useState } from 'react';
import { useAppStore } from '../store/AppContext';
import { useAuthStore } from '../store/AuthContext';
import { GtmManager } from '../utils/GtmManager';
import { IPManager } from '../utils/IPManager';

function useDatalayerEvents(category: string) {
  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const [ipValue, setIpValue] = useState('' as string);

  useEffect(() => {
    if (ipValue !== '') {
      GtmManager.sendPageInfoGtm(category, dataApp, dataUser, ipValue);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ipValue]);

  useEffect(() => {
    if (dataUser.user.email !== '') {
      IPManager.getMyIp(setIpValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.email]);
}

export default useDatalayerEvents;
